import { render, staticRenderFns } from "./documents-upload-page.vue?vue&type=template&id=a98aa5f8&"
import script from "./documents-upload-page.vue?vue&type=script&lang=js&"
export * from "./documents-upload-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports